import DiagramApi from '../../api/DiagramApi';
import TreeDiagram from '../../views/SystemSettings/Diagram/TreeDiagram';
import DirectedGraphDiagram from '../../views/SystemSettings/Diagram/DirectedGraphDiagram';
import useResourceLoader from '../../util/useResourceLoader';
import Loader from '../Loader';

import { ReactFlowProvider } from '@xyflow/react';
import { useEffect, useRef, useState } from 'react';

export const WorkTrayDiagram = props => {
  const { resource } = props;

  const [graph, loadingGraph, errorLoadingGraph, setGraph] = useResourceLoader(() => DiagramApi.getDiagramGraph({ resource }), [resource]);

  return loadingGraph ? (
    <Loader fullscreen />
  ) : errorLoadingGraph || !graph ? (
    'Error when loading diagram: ' + (errorLoadingGraph || 'Unknown Error')
  ) : (
    <ReactFlowProvider>
      {graph.rootId !== null ? <TreeDiagram graph={graph} {...props} /> : <DirectedGraphDiagram graph={graph} {...props} />}
    </ReactFlowProvider>
  );
};

export default WorkTrayDiagram;
